<template>
    <v-container>
        <v-row class="text-center">
            <v-col cols="12">
                <v-img
                    src="@/assets/img/lacartaweb/lacartaweb800.png"
                ></v-img>
                <br><br>
                
                <h2>Descubre nuevos sabores</h2>

                <br>
                <v-toolbar
                elevation="0"
                >   
                    <vue-material-icon name="location_city" :size="30"></vue-material-icon>
                    <v-autocomplete
                    v-model="ciudadElegidaTemp"
                    :items="ciudades"
                    class="mx-4"
                    flat
                    hide-no-data
                    hide-details
                    label="Tu ciudad"
                    item-text="name"
                    item-value="id"
                    v-on:change="filtrarCiudad()"
                    ></v-autocomplete>
                </v-toolbar>

                <v-toolbar
                elevation="0"
                >   
                <vue-material-icon name="restaurant" :size="30"></vue-material-icon>
                <v-autocomplete
                v-model="comercioElegidoTemp"
                :items="comercios"
                class="mx-4"
                flat
                hide-no-data
                hide-details
                label="Tus restaurantes"
                item-text="name"
                item-value="slug"
                ></v-autocomplete>
                </v-toolbar>

                <br>
                <v-btn color="#ffc068" dark v-on:click="aComer()"><vue-material-icon name="restaurant_menu" :size="30"></vue-material-icon> ¡A comer!</v-btn>

                <br><br>

                <v-divider></v-divider>
                <br>

                <!--<LectorQR/>-->
                <h2 class="text-center">Lector de código QR</h2>
                
                <v-row justify="center">
                    <v-col cols="7" class="pb-0">
                        <ol>
                            <li>Acceda al lector de QR</li>
                            <li><b>Permita usar la Cámara</b></li>
                            <li>Capture el código QR del restaurante</li>
                        </ol>
                    </v-col>
                </v-row>

                <v-img
                src="@/assets/img/lacartaweb/codigo-qr.png"
                width="70%"
                class="mx-auto"
                @click="navegarNavBar('LectorQR')"
                >
                    <v-row align="center" justify="space-around" style="position:absolute;bottom:30%; left:35%">
                        <v-btn color="#ffc068" dark @click="navegarNavBar('LectorQR')">Lector QR</v-btn>
                    </v-row>
                    
                </v-img>

                <br><br>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import LectorQR from '@/views/LectorQR.vue';
    import store from '../store/index';
    import { comercio_api } from '@/api/comercio';
    import { ciudad_api } from '@/api/ciudades';


    export default {
        name: 'Inicio',
        mounted() {
            // Obtenemos todas las ciudades
            ciudad_api.getCiudad().then(res => { this.ciudades = res});
        },
        data () {
            return {
                ciudades: [],
                comercios: [],
                ciudadElegidaTemp: '',
                comercioElegidoTemp: '',
                urlBase: this.$store.state.url_base,
            }
        },
        components: { 
            LectorQR 
        },
        methods: {    
            filtrarCiudad: function () {

                ciudad_api.getCiudadId(this.ciudadElegidaTemp)
                .then( res => {
                    // Escribimos el slug e ID de la ciudad en el store
                    this.$store.commit("cambiarCiudadID", this.ciudadElegidaTemp);
                    this.$store.commit("cambiarCiudadSlug", res[0].slug);

                    // Obtenemos los restuarantes de la ciudad
                    comercio_api.getComercioIdCity(this.$store.state.ciudadElegidaID)
                    .then( res => { 
                        this.comercios = [];
                        this.comercioElegidoTemp = '';

                        // Valor por defecto: todos los restaurantes
                        this.comerciosTodos = {"id": "0", "name" : "Todos los restaurantes de la ciudad", "slug": "0"};
                        this.comercios.push(this.comerciosTodos);

                        var num_restaurantes = Object.keys(res).length;

                        // Colocamos el resto de restaurantes de la ciudad
                        if(num_restaurantes > 0){

                            for (var i = 0; i < num_restaurantes; i++) {
                                this.comercios.push(res[i]);
                            }
                        }
                    });
                });

            },
            aComer: function () {
                console.log(this.urlBase)

                // Se ha seleccionado ciudad?
                if(this.$store.state.ciudadElegidaID) {

                    
                    if(this.comercioElegidoTemp == "0" || this.comercioElegidoTemp == ""){
                        console.log(this.urlBase)

                        // Todos los restaurantes de una ciudad: Ir a localidad
                        window.location.href = this.urlBase+'/'+this.$store.state.ciudadElegidaSlug;

                    }
                    else {

                        // Un restaurante en concreto: 1.CambiarStore 2.Ir a restaurante
                        comercio_api.getComercioSlug(this.comercioElegidoTemp)
                        .then( res => { 
                            this.$store.commit("cambiarComercioSlug", this.comercioElegidoTemp);
                            this.$store.commit("cambiarComercioID", res[0].id);

                            window.location.href = this.urlBase+'/'+this.$store.state.comercioElegidoSlug;

                        });
                    }
                }
                else {
                    alert("Debe seleccionar una ciudad")
                }
                
            },
            navegarNavBar: function (tipo) {
                this.$store.commit("cambiarCiudadID", '');
                this.$store.commit("cambiarCiudadSlug", '');
                this.$store.commit("cambiarComercioID", '');
                this.$store.commit("cambiarComercioSlug", '');
                this.$store.commit("cambiarTipo", tipo);

                if (tipo === 'LectorQR') {
                    this.$store.commit("cambiarTipo", "LectorQR");
                    window.location.href = this.urlBase+'/lectorqr';
                }
            },
        }
    }

</script>